export default __webpack_public_path__ + "static/media/rathymol.42e23956.jpg";